import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ViewChild } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject } from 'rxjs';
declare var $: any;

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],
})
export class ImageUploadComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  @Output() profilePic = new EventEmitter();
  @Output() blogImage = new EventEmitter();
  @ViewChild('fileupload') fileupload: ElementRef;

  isCameraExist = true;
  showCamera = false;
  cropView = false;
  cameraImage: any = null;
  @Input() aspectRatio: number;
  @Input() mode: string;

  errors: WebcamInitError[] = [];
  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  constructor() {}

  ngOnInit(): void {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    // show cropper
  }

  cropperReady() {
    // cropper ready
    this.cropView = true;
  }

  loadImageFailed() {
    // show message
  }

  clear() {
    this.croppedImage = '';
    this.imageChangedEvent = '';
    if(this.fileupload){
      this.fileupload.nativeElement.value = '';
    }
    this.cameraImage = null;
    this.cropView = false;
    // this.showCamera = false;
  }

  clearBlogImage(){
    if(this.mode == 'blog pic')
    {
      this.blogImage.emit(null);
    }
  }

  onApply() {
    $('#image-upload').modal('hide');
    if(this.mode == 'profile pic'){
      this.profilePic.emit(this.croppedImage);
    }
    else if(this.mode == 'blog pic')
    {
      this.blogImage.emit(this.croppedImage);
    }
    this.clear();
  }

  webCamInit(){
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.isCameraExist = mediaDevices && mediaDevices.length > 0;
      });
  }

  takeSnapshot(): void {
    this.trigger.next();
  }

  handleInitError(error: WebcamInitError) {
    this.errors.push(error);
  }

  changeWebCame(directionOrDeviceId: boolean | string) {
    this.nextWebcam.next(directionOrDeviceId);
  }

  handleImage(webcamImage: WebcamImage) {
    this.cameraImage = webcamImage.imageAsDataUrl;
    this.showCamera = false;
  }

  get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }
}
